export const AboutUs = () => (
    <>
        <div className="block-about-us">
            <h2>ПРО НАС</h2>
            <div className="info-block">
                <div className="text-block">
                    <p>
                        Astro Club — це твій простір для розвитку особистості, нових знайомств та пошуку себе. <br />
                        <br />
                        Ми поєднуємо науку, творчість та сучасні практики, пропонуючи простір для особистісного зростання. У нас ти зможеш досліджувати астрономію, вивчати психологію, астрологію, психосоматику, а також розвивати навички у сфері косметології, візажу, SMM і відеозйомки.<br />
                        <br />
                        Наша мета — допомогти кожному знайти себе, розкрити потенціал і створити коло однодумців для обміну ідеями та досвідом.<br />
                        <br />
                    </p>
                </div>
                <div className="image-block">
                    <img src="./img/deco/info-image.png" alt="" />
                </div>
            </div>
            <div className="info-block">
                <div className="text-block">
                    <p>
                        Astro Club — це твій простір для розвитку особистості, нових знайомств та пошуку себе. <br />
                        <br />
                        Ми поєднуємо науку, творчість та сучасні практики, пропонуючи простір для особистісного зростання. У нас ти зможеш досліджувати астрономію, вивчати психологію, астрологію, психосоматику, а також розвивати навички у сфері косметології, візажу, SMM і відеозйомки.<br />
                        <br />
                        Наша мета — допомогти кожному знайти себе, розкрити потенціал і створити коло однодумців для обміну ідеями та досвідом.<br />
                        <br />
                    </p>
                </div>
                <div className="image-block">
                    <img src="./img/deco/info-image.png" alt="" />
                </div>
            </div>
            <div className="contact">
              <div className="line"></div>
              <h1>ЧОМУ ВАМ ТРЕБА ДО НАС?</h1>
              <div className="line"></div>
            </div>
            <div className="why-us-section">
              <div className="cards-container">
                <div className="card-container">
                  <div className="icon">⭐</div>
                  <h3>Розвиток</h3>
                  <p>Pulvinar orci at sem egestas ultricies, lorem ipsum dolor sit amet.</p>
                </div>
                <div className="card-container">
                  <div className="icon">⭐</div>
                  <h3>Спільнота</h3>
                  <p>Pulvinar orci at sem egestas ultricies, lorem ipsum dolor sit amet.</p>
                </div>
                <div className="card-container">
                  <div className="icon">⭐</div>
                  <h3>Різноманітність</h3>
                  <p>Pulvinar orci at sem egestas ultricies, lorem ipsum dolor sit amet.</p>
                </div>
              </div>
            </div>
        </div>
    </>
)